<template>
  <modal titulo="Selecionar domínio" :loading="loading">
    <card>
      <div class="alert alert-outline-info mb-2" v-if="!loading && !opcoesDisponiveis.length">
        Nenhuma sugestão disponível para protocolar.
      </div>

      <div class="row gutters-xs" v-if="opcoesDisponiveis.length">
        <v-input
          type="select"
          label="Domínio"
          class="col-12"
          v-model="dominio"
          :options="opcoesDisponiveis"
        />
      </div>
    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <button type="button" @click.prevent="selecionar()" class="btn btn-outline-primary" v-if="opcoesDisponiveis.length">Confirmar</button>
    </template>
  </modal>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness";
  import IndisponibilidadeBusiness from "@/business/IndisponibilidadeBusiness";
  import Card from "@/components/Layout/components/Card.vue";
  import Modal from "@/components/Modal";

  export default {
    name: "ModalSelecionarDominioProtocolo",

    components: {Card, Modal},

    modal: {
      width: 450
    },

    props: {
      ordemId: String,
      tipoCancelamento: [Number, String]
    },

    data() {
      return {
        loading: true,
        dominio: null,
        opcoes: []
      }
    },

    computed: {
      opcoesDisponiveis() {
        return this.opcoes.filter(opcao => opcao.quantidade > 0);
      }
    },

    async beforeMount() {
      await this.load();
    },

    methods: {
      async load() {
        this.loading = true;

        const opcoes = [
          {id: 'RI', nome: 'Registro de Imóveis'},
          {id: 'RTD', nome: 'Registro de Títulos e Documentos'},
          {id: 'RCPJ', nome: 'Registro Civil de Pessoas Jurídicas'}
        ];

        this.opcoes = await Promise.all(opcoes.map(async opcao => {
          const quantidade = await this.quantidade(opcao.id);
          return {
            ...opcao,
            nome: `${opcao.nome} (${quantidade})`,
            quantidade
          };
        }));

        if (this.opcoesDisponiveis.length === 1) {
          this.dominio = this.opcoesDisponiveis[0].id;
        }

        this.loading = false;
      },

      async quantidade(dominio) {
        const result = await IndisponibilidadeBusiness.paginationIndisponibilidadeOrdemPessoa(
          'nome',
          'asc',
          1,
          1,
          {
            filtros: {
              ordemId: this.ordemId,
              tipoCancelamento: this.tipoCancelamento,
              dominio
            }
          }
        ).catch(e => {
          FrontBusiness.fullErrorHandler(this, e, '');
          return null;
        });

        return result?.quantidade || 0;
      },

      selecionar() {
        if (!this.dominio) return FrontBusiness.showError('', 'Necessário selecionar o domínio.');
        FrontBusiness.closeModal(this.dominio);
      },

      close() {
        FrontBusiness.closeModal();
      }
    }
  }
</script>
